import React from "react";
import { DatePicker } from "antd";
import { Calendar } from "react-feather";
import moment from "moment";

/**
 * Month or year picker for dashboard chart toolbars.
 * Compact suffix icon + dashboard CSS keep it a single 34px control
 * (global `.ant-picker input { height: 44px }` would otherwise split the field).
 */
const DashboardDatePicker = ({ mode = "month", value, onChange, className = "" }) => {
  const isMonth = mode === "month";

  return (
    <DatePicker
      picker={isMonth ? "month" : "year"}
      className={`dashboard-date-picker ${className}`.trim()}
      value={value ? moment(value) : null}
      onChange={(date) => onChange(date ? date.toDate() : null)}
      format={isMonth ? "MMM YYYY" : "YYYY"}
      allowClear={false}
      inputReadOnly
      suffixIcon={<Calendar size={14} />}
      getPopupContainer={() => document.body}
    />
  );
};

export default DashboardDatePicker;
